export default function Avatar({ name, src, className = '' }) {
  const initials = (name || '?')
    .split(' ')
    .map((n) => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  if (src) {
    return <img src={src} alt={name || 'Avatar'} className={`h-10 w-10 rounded-full object-cover ${className}`} />;
  }

  return <div className={`h-10 w-10 rounded-full bg-accent/20 text-accent flex items-center justify-center font-semibold ${className}`}>{initials}</div>;
}

